import { useNavigate } from "react-router-dom";
import Image from "../Assets/404/Scarecrow.png";
export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="container_404">
      <div className="main-wrapper">
        <picture className="scarecrow-img">
          <img src={Image} alt="scarecrow" />
        </picture>
        <div className="error-text">
          <div>
            <h2>404... UH OH! You're lost.</h2>
            <p>
              The page you are looking for does not exist. How you got here is a
              mystery. But you can click the button below to go back to the
              homepage.
            </p>
            <span className="input-group-btn">
              <button
                className="btn"
                type="button"
                onClick={() => navigate("/home")}
              >
                HOME
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
